var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle304A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 256 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M19.793 44.726A2.5 2.5 0 0 0 22.283 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6A2.5 2.5 0 0 0 28.262 36h-6.524a2.5 2.5 0 0 0-2.49 2.726l.545 6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M21.738 46a1.812 1.812 0 0 1-1.62-1.002l-.223-.445a1 1 0 1 0-1.79.894l.223.445A3.813 3.813 0 0 0 21.738 48h6.524a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 1 0-1.79-.894l-.222.445A1.812 1.812 0 0 1 28.262 46h-6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35.792 44.726A2.5 2.5 0 0 0 38.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 44.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M37.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 37.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 44.26 46h-6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M51.792 44.726A2.5 2.5 0 0 0 54.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 60.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M53.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 53.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 60.26 46h-6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M67.792 44.726A2.5 2.5 0 0 0 70.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 76.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M69.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 69.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 76.26 46h-6.523Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M83.792 44.726A2.5 2.5 0 0 0 86.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 92.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M85.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 85.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 92.26 46h-6.523Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M99.792 44.726A2.5 2.5 0 0 0 102.28 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M101.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 108.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M115.792 44.726A2.5 2.5 0 0 0 118.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M117.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 124.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M131.792 44.726A2.5 2.5 0 0 0 134.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M133.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 140.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M18.793 3.274A2.5 2.5 0 0 1 21.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 27.262 12h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M20.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 20.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 27.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34.792 3.274A2.5 2.5 0 0 1 37.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 43.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M36.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 36.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 43.26 2h-6.524Z",
  clipRule: "evenodd"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M50.792 3.274A2.5 2.5 0 0 1 53.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 59.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M52.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 52.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 59.26 2h-6.524Z",
  clipRule: "evenodd"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M66.792 3.274A2.5 2.5 0 0 1 69.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 75.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M68.737 2c-.686 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 68.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 75.26 2h-6.523Z",
  clipRule: "evenodd"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M82.792 3.274A2.5 2.5 0 0 1 85.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 91.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M84.737 2c-.686 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 84.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 91.26 2h-6.523Z",
  clipRule: "evenodd"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M98.792 3.274A2.5 2.5 0 0 1 101.28 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M100.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 100.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 107.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M114.792 3.274A2.5 2.5 0 0 1 117.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M116.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 116.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 123.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M130.792 3.274A2.5 2.5 0 0 1 133.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M132.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 132.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 139.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M146.792 3.274A2.5 2.5 0 0 1 149.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M148.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 148.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 155.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M162.792 3.274A2.5 2.5 0 0 1 165.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M164.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 164.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 171.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M178.793 3.274A2.5 2.5 0 0 1 181.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6a2.5 2.5 0 0 1-2.49 2.726h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M180.738 2c-.686 0-1.314.388-1.621 1.002l-.222.445a1 1 0 0 1-1.789-.894l.222-.446A3.813 3.813 0 0 1 180.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.223-.445A1.812 1.812 0 0 0 187.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M194.793 3.274A2.5 2.5 0 0 1 197.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6a2.5 2.5 0 0 1-2.49 2.726h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M196.738 2c-.686 0-1.314.388-1.621 1.002l-.222.445a1 1 0 0 1-1.789-.894l.222-.446A3.813 3.813 0 0 1 196.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.223-.445A1.812 1.812 0 0 0 203.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M210.793 3.274A2.5 2.5 0 0 1 213.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6a2.5 2.5 0 0 1-2.49 2.726h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M212.738 2c-.686 0-1.314.388-1.621 1.002l-.222.445a1 1 0 0 1-1.789-.894l.222-.446A3.813 3.813 0 0 1 212.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.223-.445A1.812 1.812 0 0 0 219.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M226.793 3.274A2.5 2.5 0 0 1 229.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6a2.5 2.5 0 0 1-2.49 2.726h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M228.738 2c-.686 0-1.314.388-1.621 1.002l-.222.445a1 1 0 0 1-1.789-.894l.222-.446A3.813 3.813 0 0 1 228.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.223-.445A1.812 1.812 0 0 0 235.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M252.726 18.793a2.5 2.5 0 0 1 2.274 2.49v5.434a2.5 2.5 0 0 1-2.274 2.49l-6 .545a2.5 2.5 0 0 1-2.726-2.49v-6.524a2.5 2.5 0 0 1 2.726-2.49l6 .545Z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M254 20.738c0-.686-.388-1.314-1.002-1.62l-.445-.223a1 1 0 0 1 .894-1.79l.446.223a3.813 3.813 0 0 1 2.107 3.41v6.524a3.813 3.813 0 0 1-2.107 3.41l-.446.223a1 1 0 1 1-.894-1.79l.445-.222A1.813 1.813 0 0 0 254 27.262v-6.524Z",
  clipRule: "evenodd"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.274 29.207A2.5 2.5 0 0 1 1 26.717v-5.433a2.5 2.5 0 0 1 2.274-2.49l6-.546A2.5 2.5 0 0 1 12 20.738v6.525a2.5 2.5 0 0 1-2.726 2.49l-6-.546Z"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M2 27.262c0 .687.388 1.314 1.002 1.621l.445.223a1 1 0 0 1-.894 1.789l-.446-.223A3.813 3.813 0 0 1 0 27.262v-6.524c0-1.444.816-2.764 2.107-3.41l.446-.222a1 1 0 0 1 .894 1.789l-.445.222A1.813 1.813 0 0 0 2 20.738v6.524Z",
  clipRule: "evenodd"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M147.792 44.726A2.5 2.5 0 0 0 150.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M149.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 156.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M163.792 44.726A2.5 2.5 0 0 0 166.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M165.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 172.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M179.793 44.726a2.5 2.5 0 0 0 2.49 2.274h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6a2.5 2.5 0 0 0-2.49-2.726h-6.524a2.5 2.5 0 0 0-2.49 2.726l.545 6Z"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M181.738 46a1.813 1.813 0 0 1-1.621-1.002l-.222-.445a1 1 0 0 0-1.789.894l.222.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.223.445A1.812 1.812 0 0 1 188.262 46h-6.524Z",
  clipRule: "evenodd"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M195.793 44.726a2.5 2.5 0 0 0 2.49 2.274h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6a2.5 2.5 0 0 0-2.49-2.726h-6.524a2.5 2.5 0 0 0-2.49 2.726l.545 6Z"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M197.738 46a1.813 1.813 0 0 1-1.621-1.002l-.222-.445a1 1 0 0 0-1.789.894l.222.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.223.445A1.812 1.812 0 0 1 204.262 46h-6.524Z",
  clipRule: "evenodd"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M211.793 44.726a2.5 2.5 0 0 0 2.49 2.274h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6a2.5 2.5 0 0 0-2.49-2.726h-6.524a2.5 2.5 0 0 0-2.49 2.726l.545 6Z"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M213.738 46a1.813 1.813 0 0 1-1.621-1.002l-.222-.445a1 1 0 0 0-1.789.894l.222.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.223.445A1.812 1.812 0 0 1 220.262 46h-6.524Z",
  clipRule: "evenodd"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M227.793 44.726a2.5 2.5 0 0 0 2.49 2.274h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6a2.5 2.5 0 0 0-2.49-2.726h-6.524a2.5 2.5 0 0 0-2.49 2.726l.545 6Z"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M229.738 46a1.813 1.813 0 0 1-1.621-1.002l-.222-.445a1 1 0 0 0-1.789.894l.222.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.223.445A1.812 1.812 0 0 1 236.262 46h-6.524Z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 228,
  height: 20,
  x: 14,
  y: 14,
  fill: "#464D57",
  rx: 5
})));
SvgRectangle304A.viewBox = '0 0 256 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle304A);
export default ForwardRef;